import { getTreatments as getSplitIoTreatments, initSplitSdk, splitSdk, } from '@splitsoftware/splitio-redux';
import { PURE } from '@travel-frontend/state-handling-sdk';
import { getCurrentUserId } from '@travel-frontend/user-id';
import { differenceInMilliseconds } from 'date-fns';
import { isSplitIoInitiated } from '../redux/selectors.js';
import { getSplitConfig } from '../redux/utils.js';
export const EMIT_SPLIT_CLIENT = 'split/EMIT_SPLIT_CLIENT';
export const EMIT_SPLIT_SDK_INIT = 'split/EMIT_SPLIT_SDK_INIT';
export const EMIT_SPLIT_SDK_INIT_TIMED_OUT = 'split/EMIT_SPLIT_SDK_INIT_TIMED_OUT';
export const EMIT_SPLIT_SDK_INIT_USER_ID_FETCH = 'split/EMIT_SPLIT_SDK_INIT_USER_ID_FETCH';
export function initSplit(authKey, urls) {
    return async (dispatch, getState) => {
        if (!isSplitIoInitiated(getState())) {
            dispatch(emitSplitSDKInitStarted());
            const start = new Date();
            const startFetchUserId = new Date();
            const userId = getCurrentUserId();
            const endFetchUserId = new Date();
            dispatch(emitSplitSDKInitUserIdFetch(differenceInMilliseconds(endFetchUserId, startFetchUserId)));
            await dispatch(initSplitSdk({
                config: {
                    core: {
                        authorizationKey: authKey,
                        key: userId,
                    },
                    urls,
                },
                onReady: () => {
                    const end = new Date();
                    dispatch(emitSplitClient(splitSdk.factory.client(), splitSdk.factory.manager(), differenceInMilliseconds(end, start)));
                },
                onTimedout: () => {
                    dispatch(emitSplitSDKInitTimedOut());
                },
            }));
        }
    };
}
export function emitSplitClient(client, manager, duration) {
    return {
        type: PURE(EMIT_SPLIT_CLIENT),
        client,
        manager,
        duration,
    };
}
function emitSplitSDKInitStarted() {
    return {
        type: PURE(EMIT_SPLIT_SDK_INIT),
    };
}
function emitSplitSDKInitTimedOut() {
    return {
        type: PURE(EMIT_SPLIT_SDK_INIT_TIMED_OUT),
    };
}
function emitSplitSDKInitUserIdFetch(duration) {
    return {
        type: PURE(EMIT_SPLIT_SDK_INIT_USER_ID_FETCH),
        duration,
    };
}
export function getTreatments(params, query) {
    return async (dispatch) => {
        dispatch(getSplitIoTreatments({
            ...params,
            attributes: {
                ...params.attributes,
                ...getSplitConfig(query),
            },
        }));
    };
}
//# sourceMappingURL=actions.js.map